<template>
  <v-card>
    <v-card-title>
      <span v-if="dialog.config.hasTitle">VERIFICAR E-MAIL</span>
      <v-spacer />
      <v-btn v-if="dialog.config.hasCloseButton" icon>
        <v-icon @click="close">
          mdi-close
        </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-row justify="center" class="my-4">
        <v-col cols="6">
          <t-logo stretch />
        </v-col>
      </v-row>
      <v-form
        ref="form"
        v-model="valid"
        class="py-4"
        @submit.prevent="submit"
        @keypress.enter="submit"
      >
        <v-row justify="center">
          <v-col cols="12" class="text-subtitle-1">
            Para garantir um processo de compra mais seguro precisamos verificar o seu e-mail.
            <br>
            <br>
            Enviamos um código de verificação para o endereço <strong>{{ anonymizeEmail(user.email) }}</strong>. Verifique sua caixa de entrada e insira o código para ativar sua conta.
          </v-col>
          <v-col v-if="!loading" cols="12" md="6">
            <v-otp-input
              v-model="verificationCode"
              :disabled="loading"
              :length="6"
              class="mt-4"
              hide-details
              required
            />
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col cols="12" md="6" class="px-2">
                <t-btn
                  color="primary"
                  block
                  class="heading--text"
                  large
                  :loading="loading"
                  :disabled="!valid"
                  @click="send"
                >
                  Reenviar Código
                </t-btn>
              </v-col>
              <v-col cols="12" md="6" class="px-2">
                <t-btn
                  color="success"
                  block
                  type="submit"
                  class="heading--text"
                  large
                  :loading="loading"
                  :disabled="!valid"
                >
                  Verificar E-mail
                </t-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import Vue from "vue";

import User from "@/types/User";

import TBtn from "@/components/core/TBtn.vue";
import TLogo from "../core/TLogo.vue";
import { State } from "@/store/modules/dialog";
import EmailService from "@/services/EmailService";
import getUserData from "@/api/requests/getUserData";
import { anonymizeEmail } from "@/filters/anonymize-email";

export default Vue.extend({
  name: "FormEmailVerification",

  components: {
    TBtn,
    TLogo,
  },

  data: () => ({
    valid: true,
    verificationCode: "",
  }),

  computed: {
    form(): Vue & { validate: () => boolean } {
      return this.$refs.form as Vue & { validate: () => boolean };
    },
    user(): User {
      return this.$store.state.user.data as User;
    },
    dialog(): State {
      return this.$store.state.dialog as State;
    },
    loading(): boolean {
      return this.$loader.loading();
    },
  },

  mounted() {
    this.send();
  },

  methods: {
    anonymizeEmail,
    async send() {
      this.$loader.increment();
      try {
        await new EmailService().send(this.user.document);
      } catch (e) {
        console.log(e);
      } finally {
        this.$loader.decrement();
      }
    },
    async submit() {
      this.$loader.increment();
      try {
        const code = this.verificationCode.trim();

        if (!code) {
          this.$snackbar("Por favor, insira o código de verificação!", "error");
          return;
        }

        await new EmailService().verify(this.user.document, code);
        this.$snackbar("E-mail verificado com sucesso!", "success");
        const user = (await getUserData()).data;
        this.$store.commit("user/setUser", user);
        this.close();
      } catch {
        this.$snackbar("Ocorreu um erro ao verificar o código. Tente novamente mais tarde.", "error");
      } finally {
        this.$loader.decrement();
      }
    },
    close() {
      this.$dialog.hide();
    },
  },
});
</script>
